export class PromocodeTimer {
    constructor() {
        this.setElementClasses();
        this.setEndpoint();
        this.initCountdownTimer();
    }

    setElementClasses() {
        this.HOURS_SPAN = 'js-timer-hours';
        this.MINUTES_SPAN = 'js-timer-minutes';
        this.SECONDS_SPAN = 'js-timer-seconds';
        this.COOKIE_NAME = 'BITRIX_SM_bag_coupon';
    }

    setEndpoint() {
        let cookies = document.cookie.split('; ');
        for (let str of cookies) {
            if (str.indexOf(this.COOKIE_NAME) !== -1) {
                this.endpoint = parseInt(str.replace(this.COOKIE_NAME + "=", ""), 10);
            }
        }
    }

    initCountdownTimer(){
        let countdownTo = this.endpoint * 1000,
            hourElement = $(`.${this.HOURS_SPAN}`),
            minuteElement = $(`.${this.MINUTES_SPAN}`),
            secondElement = $(`.${this.SECONDS_SPAN}`),
            $this = this;
        if (hourElement.length && minuteElement.length && secondElement.length && this.endpoint) {
            let foo = setInterval(function () {
                let now = new Date().getTime(),
                    distance = countdownTo - now,
                    hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                    minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
                    seconds = Math.floor((distance % (1000 * 60)) / 1000);
                $this.pasteFormattedResult(hourElement, hours);
                $this.pasteFormattedResult(minuteElement, minutes);
                $this.pasteFormattedResult(secondElement, seconds);

                if (distance < 0) {
                    clearInterval(foo);
                    hourElement.text('00');
                    minuteElement.text('00');
                    secondElement.text('00');
                }
            }, 1000);
        }
    }

    pasteFormattedResult(element, result) {
        element.text(result);
    }
}
